import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId
const getNamespace = () => store.state.app.namespace

export default {
  namespaced: true,
  state: {
    replicaSetResultInfo: {},
    replicaSets: [],
    replicaSet: {},
    fetchingReplicaSets: false,
    addingReplicaSet: false,
    removingReplicaSet: false,
  },
  mutations: {
    SET_REPLICA_SETS(state, data) {
      state.replicaSets = data.result
    },
    SET_REPLICA_SET(state, data) {
      state.replicaSet = data.result
    },
    SET_FETCHING_REPLICA_SETS(state, value) {
      state.fetchingReplicaSets = value
    },
    SET_ADDING_REPLICA_SET(state, value) {
      state.addingReplicaSet = value
    },
    SET_REMOVING_REPLICA_SET(state, value) {
      state.deletingReplicaSet = value
    },
  },
  actions: {
    fetchReplicaSets({ commit }) {
      commit('SET_FETCHING_REPLICA_SETS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/replicaSets`)
          .then(response => {
            commit('SET_REPLICA_SETS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_REPLICA_SETS', false) })
      })
    },
    getReplicaSet({ commit }, replicaSet) {
      commit('SET_FETCHING_REPLICA_SETS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/replicaSets/${replicaSet}`)
          .then(response => {
            commit('SET_REPLICA_SET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_REPLICA_SETS', false) })
      })
    },
    addReplicaSet({ commit }, replicaSet) {
      commit('SET_ADDING_REPLICA_SET', true)
      return new Promise((resolve, reject) => {
        api('kyubi').post(`projects/${getProjectId()}/namespaces/${getNamespace()}/replicaSets`, replicaSet)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_REPLICA_SET', false) })
      })
    },
    removeReplicaSet({ commit }, replicaSet) {
      commit('SET_REMOVING_REPLICA_SET', true)
      return new Promise((resolve, reject) => {
        api('kyubi').delete(`projects/${getProjectId()}/namespaces/${getNamespace()}/replicaSets/${replicaSet}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_REPLICA_SET', false) })
      })
    },
  },
}
